/* Slumera — quantity bundle cards. Cards with qty > 1 add N units of the chosen color.
   Prices shown match REAL automatic discounts configured in Shopify:
   2 units = 15% off (automatic discount "2 pillows: save 15%")
   3 units = 1 free (automatic discount "Buy 2, get 1 free"). Keep both in sync. */
(function(){
  var TIERS = {1:{pct:0,free:0}, 2:{pct:15,free:0}, 3:{pct:0,free:1}};
  function fmt(tpl, n){
    var m = tpl.match(/[\d.,\s]*\d/); if(!m) return n.toFixed(2);
    var num = m[0], dec = /,\d{2}$/.test(num.trim()) ? ',' : '.', th = dec === ',' ? '.' : ',';
    var parts = n.toFixed(2).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return tpl.replace(num, int + dec + parts[1]);
  }
  function parse(s){
    var m = (s||'').match(/[\d.,\s]*\d/); if(!m) return 0;
    var t = m[0].replace(/\s/g,''); var dec = /,\d{2}$/.test(t) ? ',' : '.';
    t = dec === ',' ? t.replace(/\./g,'').replace(',', '.') : t.replace(/,/g,'');
    return parseFloat(t) || 0;
  }
  function init(){
    document.querySelectorAll('[data-dl-bundles]').forEach(function(wrap){
      var cards = [].slice.call(wrap.querySelectorAll('[data-dl-bundle]'));
      if(!cards.length || !cards.some(function(c){ return +c.getAttribute('data-qty') > 1; })) return;
      var root = wrap.closest('.dl-pdp') || document;
      var select = root.querySelector('[data-dl-variant]');
      var priceEl = root.querySelector('[data-dl-price]');
      var compareEl = root.querySelector('[data-dl-compare]');
      wrap.classList.add('slm-offers');
      cards.forEach(function(c){ ['data-variant-id','data-variant-price','data-variant-compare','data-variant-available'].forEach(function(a){ c.removeAttribute(a); }); });
      if(select){ select.selectedIndex = 0; }
      if(select){
        var box = select.parentElement; box.style.display = 'flex';
        var lab = document.createElement('span'); lab.className = 'slm-label'; lab.textContent = 'Color';
        box.parentElement.insertBefore(lab, box);
        [].forEach.call(select.options, function(o){ o.textContent = o.textContent.split(' — ')[0]; });
        wrap.parentElement.insertBefore(lab, wrap.previousElementSibling || wrap);
        wrap.parentElement.insertBefore(box, wrap.previousElementSibling || wrap);
      }
      function unitTpl(){ var o = select && select.options[select.selectedIndex]; return o ? o.getAttribute('data-price') : (priceEl ? priceEl.textContent : ''); }
      function calc(c){
        var q = +c.getAttribute('data-qty') || 1, t = TIERS[q] || {pct:0,free:0}, tpl = unitTpl(), u = parse(tpl);
        var uc = Math.round(u*100), offc = Math.floor(uc*t.pct/100); /* Shopify rounds the % per unit down to the cent */
        var full = u*q, total = ((uc - offc)*(q - t.free))/100;
        return {tpl:tpl, q:q, full:full, total:total, each:total/q, save:full-total};
      }
      function render(){
        cards.forEach(function(c){
          var r = calc(c), col = c.lastElementChild;
          var h = '<b class="slm-p">'+fmt(r.tpl,r.total)+'</b>';
          if(r.save > 0.005) h += '<s class="slm-c">'+fmt(r.tpl,r.full)+'</s>';
          h += '<span class="slm-e">'+fmt(r.tpl,r.each)+' each</span>';
          if(r.save > 0.005) h += '<span class="slm-s">You save '+fmt(r.tpl,r.save)+'</span>';
          col.innerHTML = h; col.className = 'slm-col';
          var bd = c.querySelector('.dl-bdg'); if(bd && /best/i.test(bd.textContent)) bd.classList.add('slm-best');
        });
        var on = wrap.querySelector('input[type=radio]:checked'); setMain(on ? on.closest('[data-dl-bundle]') : cards[0]);
      }
      function setMain(c){
        if(!c) return; var r = calc(c);
        setTimeout(function(){
          if(priceEl) priceEl.textContent = fmt(r.tpl, r.total);
          if(compareEl){ compareEl.textContent = r.save > 0.005 ? fmt(r.tpl, r.full) : ''; compareEl.style.display = r.save > 0.005 ? '' : 'none'; }
        }, 0);
      }
      cards.forEach(function(c){ c.addEventListener('click', function(){ setMain(c); }); });
      if(select) select.addEventListener('change', function(){ setTimeout(render, 0); });
      render();
      var pre = wrap.querySelector('input[type=radio]:checked');
      (pre ? pre.closest('[data-dl-bundle]') : cards[0]).click();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
